import React from 'react'
import { FaAngleDown, FaAngleUp } from 'react-icons/lib/fa'
import PropTypes from 'prop-types'
import styles from './SortableTableHeader.scss'

const SortableTableHeader = ({type, label, onClick, sortDirection, sortBy}) => {
  return <th onClick={onClick}
    className={styles.SortableTableHeader}>
    {label}
    {
      type === sortBy &&
      (
        sortDirection === 'DESC'
        ? <FaAngleDown />
        : <FaAngleUp />
      )
    }
  </th>
}

SortableTableHeader.propTypes = {
  sortDirection: PropTypes.string,
  sortBy: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func
}

export default SortableTableHeader



// WEBPACK FOOTER //
// ./src/components/SortableTableHeader/SortableTableHeader.js